import $api from '@/apiProvider'
import $C from "@/consts/index";
import {
  searchTime,
  SEARCH_TIME
} from "@/filters/time";
import moment from "moment";
import Import from "@/components/common/Import"; // 导入
import NewCreatePayment from "@/components/modal/PayOrder.vue";
import CreatePayment from "./CreatePayment.vue";
import PaymentDetail from './PaymentDetail.vue'
import SearchFilters from '@/components/common/SearchFilters'
import getAuthOrization from "@/mixin/getAuthOrization";
import {
  orderDetail,
  paymentFooter,
  goReceiveGoods,
  getBlob,
  saveBlob,
  showLoading,
  hideLoading
} from '@/utils/util'
import SellerReceivingDetail from "../receiving/SellerReceivingDetail";
import SecondReceivingDetail from "../receiving/SecondReceivingDetail";
import openProcedureDetail from "@/mixin/viewOrderDetail";
import {
  isEmpty
} from "@/utils/util";
import BuyerReceivingDetail from "@/views/receiving/BuyerReceivingDetail";
import CarryOverDetail from "@/views/payment/CarryOverDetail.vue";

const empties = [undefined, '', null, 'null', {},
  []
]

export default {
  mixins: [getAuthOrization, openProcedureDetail],
  name: 'PaymentList',
  components: {
    Import,
    SearchFilters,
    CreatePayment,
    PaymentDetail,
    NewCreatePayment,
    SellerReceivingDetail,
    SecondReceivingDetail,
    BuyerReceivingDetail,
    CarryOverDetail
  },
  props: {
    cate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      isImport: false,
      searchLoading: false,
      queryAction: '',
      deleteAction: '',

      templateVisible: false, //导入
      isShowCreatePayment: false, //添加弹窗
      isShowPaymentDetail: false, //详情弹窗
      isShowImportPayment: false, //导入收付款
      isNewShowCreatePayment: false,
      receivingDeailModal: false,
      secondReceivingDeailModal: false,
      sellerReceivingDeailModal: false,
      isShowCarryOverDetail: false,
      tableData: [],
      totalCounts: '',
      totalAmount: '',
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      searchParams: {
        addTimeBegin: '',
        addTimeEnd: ''
      },
      timeVal: "",
      rangeTime: "time",
      open: false,
      startTime: '',
      endTime: '',
      timeOptions: SEARCH_TIME.options,
      fileOptions: $C.HAS_FILE_TYPE.options,
      searchPaymentsName: [],
      searchPayAccount: [],
      searchRecName: [],
      searchRecAccount: [],
      searchSalesMan: [],
      searchClientName: [],
      searchOwnName: [],
      searchCompName: [],
      searchCreateUser: [],
      paymentsNameOptions: [],
      payAccountOptions: [],
      recNameOptions: [],
      recAccountOptions: [],
      salesManOptions: [],
      clientNameOptions: [],
      compNameOptions: [],
      ownNameOptions: [],
      createUserOptions: [],
      searchFormData: {
        paymentsNum: null,
        paymentsName: null,
        payAccount: null,
        recName: null,
        recAccount: null,
        payBankCode: null,

        addTime: null,

        chainNum: null,
        ordersNum: null,
        note: null,

        salesMan: null,
        clientName: null,
        compName: null,
        flowNum: null,
        createUser: null,
        createTime: null,
        hasFile: null,
        isBindOrder: null
      },
      searchFormItems: [{
          field: "paymentsNum",
          title: "收款信息编号",
          span: 4,
          titleAlign: "right",
          itemRender: {
            name: "$input",
            props: {
              placeholder: "输入收款信息编号"
            },
          },
        },
        {
          field: "flowNum",
          title: "流程编号",
          span: 4,
          titleAlign: "right",
          itemRender: {
            name: "$input",
            props: {
              placeholder: "输入流程编号"
            },
          },
        },
        {
          field: "payBankCode",
          title: "支付流水号",
          titleAlign: "right",
          span: 4,
          itemRender: {
            name: "$input",
            props: {
              placeholder: "输入支付流水号"
            }
          },
        },
        {
          field: "chainNum",
          title: "主订单编号",
          titleAlign: "right",
          span: 4,
          itemRender: {
            name: "$input",
            props: {
              placeholder: "输入主订单编号"
            }
          },
        },
        {
          field: "ordersNum",
          title: "子订单编号",
          titleAlign: "right",
          span: 4,
          itemRender: {
            name: "$input",
            props: {
              placeholder: "输入子订单编号"
            }
          },
        },
        {
          field: "note",
          title: "摘要",
          titleAlign: "right",
          span: 4,
          itemRender: {
            name: "$input",
            props: {
              placeholder: "输入摘要"
            }
          },
        },
        {
          field: "createTime",
          title: "按创建时间",
          titleAlign: "right",
          span: 4,
          itemRender: {
            name: "$select",
            props: {
              placeholder: "请选择时间",
              transfer: false
            },
            options: SEARCH_TIME.options,
          }
        },
        {
          field: "hasFile",
          title: "附件筛查",
          titleAlign: "right",
          span: 4,
          itemRender: {
            name: "$select",
            props: {
              placeholder: "请选择是否包含附件",
              transfer: false
            },
            options: $C.HAS_FILE_TYPE.options,
          },
        },
      ],
    };
  },
  watch: {
    cate: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.searchFormItems[1].title = val == 'Collection' ? '收款信息编号' : '付款信息编号'
        switch (this.cate) {
          case 'Collection':
            this.queryAction = 'queryPaymentsBuyerList'
            this.deleteAction = 'removePaymentsBuyer'
            break;
          case 'Payment':
            this.queryAction = 'queryPaymentsSellerList'
            this.deleteAction = 'removePaymentsSeller'
            break
          case 'SellerPayment':
            this.queryAction = 'queryPaymentsSellerLv2List'
            this.deleteAction = 'removePaymentsSellerLv2'
            break
        }
      }
    },
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
  },
  mounted() {
    this.$bus.$on("应付账款", () => {
      this.reset()
      this.startTime = moment().startOf("month").format("YYYY-MM-DD");
      this.endTime = moment().endOf('day').format("YYYY-MM-DD");
    });
    this.startTime = moment().startOf("month").format("YYYY-MM-DD");
    this.endTime = moment().endOf('day').format("YYYY-MM-DD");
    this.getList('', 'paymentsNameOptions', 'payments', 'queryPaymentsKeyword', 1);
    this.getList('', 'recNameOptions', 'payments', 'queryPaymentsKeyword', 2);
    // this.getList('', 'payAccountOptions', 'payments', 'queryPaymentsKeyword', 3);
    // this.getList('', 'recAccountOptions', 'payments', 'queryPaymentsKeyword', 4);
    this.getList('', 'salesManOptions', 'payments', 'queryPaymentsKeyword', 5);
    this.getList('', 'clientNameOptions', 'payments', 'queryPaymentsKeyword', 6);
    this.getList('', 'compNameOptions', 'payments', 'queryPaymentsKeyword', 7);
    this.getList('', 'createUserOptions', 'payments', 'queryPaymentsKeyword', 8);
    this.getList('', 'ownNameOptions', 'payments', 'queryPaymentsKeyword', 9);
  },
  methods: {
    reset() {
      this.searchFormData = {
        paymentsNum: null,
        paymentsName: null,
        payAccount: null,
        recName: null,
        recAccount: null,
        payBankCode: null,
        addTime: null,
        chainNum: null,
        ordersNum: null,
        note: null,
        salesMan: null,
        clientName: null,
        compName: null,
        flowNum: null,
        createUser: null,
        createTime: null,
        hasFile: null,
        isBindOrder: null
      }
      this.startTime = '';
      this.endTime = '';
      this.searchPaymentsName = [];
      this.searchPayAccount = [];
      this.searchRecName = [];
      this.searchRecAccount = [];
      this.searchSalesMan = [];
      this.searchClientName = [];
      this.searchCompName = [];
      this.searchOwnName = [];
      this.searchCreateUser = [];
      this.tableData = [];
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {},
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.visible = true;
      }, 100);
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        columnType: columnType,
        moduleType: 2
      };

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        this[options] = res.data;
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    init() {
      // this.getListData()
    },
    setSearchParams(searchParams) {
      this.searchParams = searchParams
    },
    getSearchListKey() {
      if (this.startTime === '' && this.endTime === '' && this.searchPaymentsName.length === 0 &&
        (this.searchFormData.paymentsNum === '' || this.searchFormData.paymentsNum === null) &&
        (this.searchFormData.flowNum === '' || this.searchFormData.flowNum === null) &&
        (this.searchFormData.payBankCode === '' || this.searchFormData.payBankCode === null) &&
        (this.searchFormData.chainNum === '' || this.searchFormData.chainNum === null) &&
        (this.searchFormData.ordersNum === '' || this.searchFormData.ordersNum === null) &&
        (this.searchFormData.createTime === '' || this.searchFormData.createTime === null) &&
        (this.searchFormData.hasFile === '' || this.searchFormData.hasFile === null) &&
        (this.searchFormData.isBindOrder === '' || this.searchFormData.isBindOrder === null) &&
        this.searchPayAccount.length === 0 &&
        this.searchRecName.length === 0 &&
        this.searchRecAccount.length === 0 &&
        this.searchSalesMan.length === 0 &&
        this.searchClientName.length === 0 &&
        this.searchCompName.length === 0 &&
        this.searchOwnName.length === 0 &&
        this.searchCreateUser.length === 0) {
        this.$XModal.alert({
          message: "请输入搜索条件",
          status: "error",
        });
        return
      }
      let obj = this.searchFormData;
      let searchParams = {};
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== null && key !== "createTime") {
          searchParams[key] = obj[key];
        }
        if (obj["createTime"] && obj["createTime"].length > 0) {
          searchParams.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
          searchParams.createTimeEnd = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
        }
      });
      searchParams.paymentsName = this.searchPaymentsName;
      searchParams.payAccount = this.searchPayAccount;
      searchParams.recName = this.searchRecName;
      searchParams.recAccount = this.searchRecAccount;
      searchParams.salesMan = this.searchSalesMan;
      searchParams.clientName = this.searchClientName;
      searchParams.compName = this.searchCompName;
      searchParams.ownName = this.searchOwnName;
      searchParams.createUser = this.searchCreateUser;
      this.searchParams = searchParams
      this.getListData();
    },
    async download() {
      if (isEmpty(this.tableData)) {
        this.$XModal.message("先搜索数据")
        return
      }
      if (this.cate === "Payment") {
        showLoading();
        let res = getBlob("/api/order/payments/exportPaymentsSellerList", this.searchParams);
        hideLoading();
        await saveBlob("导出应付账款.xls", res.data);
      } else if (this.cate === "SellerPayment") {
        showLoading();
        let res = getBlob("/api/order/payments/exportPaymentsSellerLv2List", this.searchParams);
        hideLoading();
        await saveBlob("导出实际承运人应付款.xls", res.data);
      } else {
        console.log(this.cate);
      }
    },
    async getListData() {
      this.loading = true;
      this.searchParams.addTimeBegin = this.startTime === '' ? this.startTime : this.$utils.timestamp(this.startTime);
      this.searchParams.addTimeEnd = this.endTime === '' ? this.endTime : (this.$utils.timestamp(this.endTime) + 86399000);
      let params = empties.includes(this.searchParams) ? {} : this.searchParams
      params.orderBy = 3;
      params.isDesc = 0;
      // params.isBindOrder = 1;
      let res = await $api.payments.request(this.queryAction, params)
      if (res.status == 1) {
        res.data.rows.forEach(row => {
          if (row.paymentsState === 1) {
            row.paymentsNum = row.receiveNum
          }
        })
        this.tableData = res.data.rows;
        let firstRow = {
          debiteAmount: '期初余额：',
          balanceAmount: res.data.countRtnVo.beginBalanceAmount
        }
        this.tableData.unshift(firstRow);
        this.loading = false;
      } else {
        if (empties.includes(res.message)) res.message = '接口异常'
        this.$XModal.message(res.message)
      }
    },
    pageChange(page) {
      this.page.currentPage = page.currentPage
      this.page.pageSize = page.pageSize
      this.getListData()
    },
    footerCellClassName({
      $rowIndex,
      column,
      columnIndex
    }) {
      return 'footer-cell'
    },
    footerMethod({
      columns,
      data
    }) {
      return paymentFooter({
        columns,
        data
      })
    },
    async cellClickEvent(e) {
      console.log(e)
      let field = e.column.property
      let row = e.row
      if (field === 'paymentsNum') {
        if (e.row.sourceType === 6) {
          // 打开结转流程
          this.viewCarryOverDetail(e.row.id)
        } else {
          if (e.row.paymentsState === 2) {
            this.viewDetail(e.row)
          } else {

            if (e.row.receiveNum.indexOf("CG") != -1) {
              if (!this.isHavePermission('buyer:ReceDetail')){
                this.$Message["info"]({
                  background: true,
                  content: "对不起，您没有该权限！"
                });
                return ;
              }
              this.receivingDeailModal = true;
              this.$refs.receivingDetail.getReceivingDetail({
                id: e.row.receiveGoodsId
              });
            } else if (e.row.receiveNum.indexOf("CS") != -1) {
              if (!this.isHavePermission('seller:ReceDetail')){
                this.$Message["info"]({
                  background: true,
                  content: "对不起，您没有该权限！"
                });
                return ;
              }
              this.sellerReceivingDeailModal = true;
              // this.getReceivingDetail(row);
              this.$refs.sellerReceivingDetail.getReceivingDetail({
                id: e.row.receiveGoodsId
              });
            } else if (e.row.receiveNum.indexOf("CA") != -1) {
              if (!this.isHavePermission('sellerLv2:ReceDetail')){
                this.$Message["info"]({
                  background: true,
                  content: "对不起，您没有该权限！"
                });
                return ;
              }
              this.secondReceivingDeailModal = true;
              // this.getReceivingDetail(row);
              this.$refs.secondReceivingDetail.getReceivingDetail({
                id: e.row.receiveGoodsId
              });
            }
            // this.isShowBuyerReceivingDetail = true
            // this.$refs.buyerReceivingDetail.getReceivingDetail({id: e.row.receiveGoodsId})
          }
        }

      } else if (field == 'chainNum' && !empties.includes(row.chainId)) {
        this.openOrderDetail(row.chainId, 0)
        // orderDetail(this, 0, row.chainId)
      } else if (field == 'ordersNum' && !empties.includes(row.ordersId)) {
        let firWord = row.ordersNum.substr(0, 1);
        if (firWord == 'G') {
          this.openOrderDetail(row.ordersId, 1)
          // orderDetail(this, 1, row.ordersId)
        } else if (firWord == 'S') {
          this.openOrderDetail(row.ordersId, 2)
          // orderDetail(this, 2, row.ordersId)
        } else {
          this.openOrderDetail(row.ordersId, 3)
        }
      }
    },
    viewDetail(row) {
      if (!this.isHavePermission('PaymentsSeller')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.isShowPaymentDetail = true
      this.$refs.paymentDetail.setEdit(false)
      this.$refs.paymentDetail.init(row.id)
    },
    editDetail(row) {
      if (!this.isHavePermission('PaymentsSeller')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.isShowPaymentDetail = true
      this.$refs.paymentDetail.setEdit(true)
      this.$refs.paymentDetail.init(row.id)
    },
    async delEvent(row) {
      let confirm = await this.$XModal.confirm({
        title: '提示',
        message: '是否删除',
        'confirm-button-text': '确定',
        'cancel-button-text': '取消'
      })
      if (confirm == 'cancel') return
      let params = {
        id: row.id
      }
      let res = await $api.payments.request(this.deleteAction, params)
      if (res.status == 1) {
        this.$XModal.message('删除成功')
      }
      this.getListData()
    },
    showCreatePayment() {
      this.isImport = false
      this.isShowCreatePayment = true
    },
    showNewCreatePayment() {
      this.isImport = false
      this.isNewShowCreatePayment = true
      this.$refs.createNewPaymentModal.initByCate('payment');
    },
    showTempModal() {
      if (this.cate == 'Collection') {
        this.$refs.modalTemplate.setExport('707托运人付款信息导入模板.xls');
      } else if (this.cate == 'Payment') {
        this.$refs.modalTemplate.setExport('708承运人收款信息导入模板.xls');
      } else if (this.cate == 'SellerPayment') {
        this.$refs.modalTemplate.setExport('709实际供应方收款信息导入模板.xls');
      }
      this.templateVisible = true;
    },
    goImport() {
      this.templateVisible = false;
      this.isImport = true
      this.title = '发票信息导入';
      this.isShowCreatePayment = true
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    authCreate() {
      return this.cate == 'Collection' && this.isHavePermission('payments:createPaymentsBuyer') ||
        this.cate == 'Payment' && (this.isHavePermission('payments:createPaymentsSeller') || this.isHavePermission('payments:createPaymentsSellerOnline')) ||
        this.cate == 'SellerPayment' && this.isHavePermission('payments:createPaymentsSellerLv2')
    },
    authRemove() {
      return this.cate == 'Collection' && this.isHavePermission('payments:removePaymentsBuyer') ||
        this.cate == 'Payment' && this.isHavePermission('payments:removePaymentsSeller') ||
        this.cate == 'SellerPayment' && this.isHavePermission('payments:removePaymentsSellerLv2')
    },
    authUpdate() {
      return this.cate == 'Collection' && this.isHavePermission('payments:updatePaymentsBuyer') ||
        this.cate == 'Payment' && this.isHavePermission('payments:updatePaymentsSeller') ||
        this.cate == 'SellerPayment' && this.isHavePermission('payments:updatePaymentsSellerLv2')
    },
    authDownload() {
      return this.cate == 'Collection' && this.isHavePermission('payment:collection:download') ||
        this.cate == 'Payment' && this.isHavePermission('payment:payment:download') ||
        this.cate == 'SellerPayment' && this.isHavePermission('payment:sellerpayment:download')
    },
    viewCarryOverDetail(id) {
      this.isShowCarryOverDetail = true;
      this.$refs.carryOverDetail.initDetail(id);
    }
  },
};
